// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3G7ZC","label":"Radio_label__1tJxi","checkMark":"Radio_checkMark__3zXFY","disabled":"Radio_disabled__1n9nn"};